import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Request } from '../../../classes/request';
import { Document } from '../../../classes/document';
import { DocumentService } from '../../../services/document';
import { FileService } from '../../../services/file';
import { RequestService } from '../../../services/request';
import { DocumentPreviewPaneComponent } from '../../../components/document-preview-pane/document-preview-pane.component';

const REVENUE_STAMP_DOCUMENT_TYPE = 3;

@Component({
    selector: 'app-request-revenue-stamp-modal',
    templateUrl: './request-revenue-stamp-modal.component.html',
    styleUrls: ['./request-revenue-stamp-modal.component.css']
})
export class RequestRevenueStampModalComponent implements OnInit {
    @ViewChild(DocumentPreviewPaneComponent) previewPane?: DocumentPreviewPaneComponent;

    @Input() request: Request = new Request();

    revenueStamp = '';
    stampDocument: Document | null = null;
    documentLoading = true;
    documentLoadFailed = false;
    saving = false;
    saveError = '';

    constructor(public activeModal: NgbActiveModal,
                private documentService: DocumentService,
                private fileService: FileService,
                private requestService: RequestService) {
    }

    ngOnInit(): void {
        this.revenueStamp = this.request.RevenueStamp || '';
        this.loadStampDocument();
    }

    loadStampFile = () => this.fileService.download(
        this.request.IDRequest!.toString(),
        REVENUE_STAMP_DOCUMENT_TYPE.toString(),
        this.stampDocument!.Path
    );

    save(): void {
        if (this.saving || !this.request.IDRequest) {
            return;
        }
        this.saving = true;
        this.saveError = '';
        const revenueStamp = this.revenueStamp.trim();
        this.requestService.update({
            IDRequest: this.request.IDRequest,
            RevenueStamp: revenueStamp
        } as Request)
            .subscribe({
                next: () => {
                    this.request.RevenueStamp = revenueStamp;
                    this.saving = false;
                    this.activeModal.close(this.request);
                },
                error: (err: HttpErrorResponse) => {
                    this.saving = false;
                    this.saveError = 'Impossibile salvare la marca da bollo.';
                    console.log(err);
                }
            });
    }

    private loadStampDocument(): void {
        if (!this.request.IDRequest) {
            this.documentLoading = false;
            return;
        }
        this.documentService.getAllByIDRequest(this.request.IDRequest.toString())
            .subscribe({
                next: (documentsByType: any) => {
                    const bucket = documentsByType?.[REVENUE_STAMP_DOCUMENT_TYPE];
                    this.stampDocument = Array.isArray(bucket) && bucket.length > 0
                        ? bucket[bucket.length - 1]
                        : null;
                    this.documentLoading = false;
                },
                error: (err: HttpErrorResponse) => {
                    this.documentLoadFailed = true;
                    this.documentLoading = false;
                    console.log(err);
                }
            });
    }
}
